import styled from 'styled-components/macro'

import { IconClock, IconAttention } from '@loadsmart/icons'
import { Button } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const BidInputWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row nowrap;
  justify-content: center;
  width: 100%;
`

export const ErrorIcon = styled(IconAttention)`
  display: block;
  height: 48px;
  margin: 0 auto 20px;
  width: 48px;
`

export const LoadingWrapper = styled.div`
  display: flex;
  min-height: 300px;
  align-items: center;
  justify-content: center;
  width: 100%;
`

export const PendingIcon = styled(IconClock)`
  display: block;
  height: 48px;
  margin: 0 auto;
  width: 48px;
`

export const BidPriceInput = styled.input`
  background: none;
  border: none;
  border-bottom: 1px solid
    ${({ hasError }) => (hasError ? getToken('color-danger') : getToken('color-neutral-darker'))};
  color: ${({ hasError }) =>
    hasError ? getToken('color-danger') : getToken('color-neutral-darker')};
  font-size: 38px;
  font-weight: bold;
  outline: none;
  padding-bottom: 4px;
  resize: none;
  text-align: center;
  transition: color 100ms, border-bottom-color 100ms;
  width: 200px;
`

export const RemoveButton = styled(Button)`
  color: ${getToken('color-danger')};

  :hover {
    color: ${getToken('color-danger')} !important;
  }
`
